import Button from '@passkeys/ui/button';
import Icon from '@passkeys/ui/icon';
import Skeleton from '@passkeys/ui/skeleton';

import exodus from '@/ui/exodus';
import useFiatEnabled from '@/ui/hooks/use-fiat-enabled';
import useNavigate from '@/ui/hooks/use-navigate';
import showSelectChainModal from '@/ui/modals/select-chain-modal';
import { createNavigateStateOptions } from '@/ui/utils/navigation';
import type { BuyPageLocationState } from '../../buy/types.js';

function Actions() {
  const navigate = useNavigate();

  const { enabled: isFiatEnabled, loading } = useFiatEnabled();

  const handleReceiveClick = async () => {
    const { result: chain } = await showSelectChainModal();
    if (chain) {
      // `chain.name` is the base asset name of the selected chain, which is a token name.
      const token = chain.name;
      navigate(`/tokens/${token}/receive`);
    }

    exodus.analytics.track({
      event: 'WalletReceiveSelectAssetView',
    });
  };

  return (
    <div className="flex items-center justify-center gap-x-2 py-4">
      {loading ? (
        <>
          <Skeleton width={128} height={40} shape="circle" />
          <Skeleton width={128} height={40} shape="circle" />
        </>
      ) : (
        <>
          {isFiatEnabled && (
            <Button
              className="w-32"
              prefix={<Icon name="currency-circle" size={24} />}
              onClick={() =>
                navigate(
                  '/buy',
                  createNavigateStateOptions<BuyPageLocationState>({
                    referrer: 'tokens',
                  }),
                )
              }
              variant="rounded"
            >
              Buy
            </Button>
          )}
          <Button
            className="w-32"
            prefix={<Icon name="arrow-down-circle" size={24} />}
            onClick={handleReceiveClick}
            variant="rounded"
          >
            Receive
          </Button>
        </>
      )}
    </div>
  );
}

export default Actions;
